import React, { Suspense, useMemo } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Cookies from 'universal-cookie';

import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import routes from './routes/routes';
import { CustomRoute } from './types/customRoute';
import { QueryClient, QueryClientProvider } from 'react-query';
import Spinner from './components/Spinner/Spinner';
import { useEmbeddedSessionInit } from './hooks/auth/useEmbeddedSessionInit';
import { useMaintenanceMode } from './hooks/useMaintenanceMode';
import MaintenancePage from './components/MaintenancePage/MaintenancePage';
import { applyVendorTheme } from './theme/vendorTheme';
import { VENDOR_NAME_KEY } from './theme/vendorConstants';

const _hostParam = new URLSearchParams(window.location.search).get('host');
if (_hostParam) {
  sessionStorage.setItem(VENDOR_NAME_KEY, _hostParam);
} else if (!new Cookies().get('token') && !sessionStorage.getItem('token')) {
  sessionStorage.removeItem(VENDOR_NAME_KEY);
}
applyVendorTheme();

function App() {
  const queryClient = useMemo(() => new QueryClient(), []);
  const { isInitializing } = useEmbeddedSessionInit();
  const { isLoading: isMaintenanceLoading, isMaintenanceMode } =
    useMaintenanceMode();

  if (isMaintenanceLoading || isInitializing) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <Spinner />
    </div>
  );
  if (isMaintenanceMode) return <MaintenancePage />;

  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Spinner />}>
          <Switch>
            {routes.map((route: CustomRoute, i: number) => (
              <Route
                key={i}
                path={route.path}
                exact={route.exact}
                render={route.render}
              />
            ))}
          </Switch>
        </Suspense>
      </QueryClientProvider>
      <ToastContainer position={'bottom-right'} autoClose={2000} />
    </div>
  );
}

export default App;
